import { useState, useEffect } from 'react';

import { v4 as uuidv4 } from 'uuid';

//------------------------------------------------
const LOCAL_STORAGE_KEY = "local_storage_posts"

const usePosts = () => {

    const [posts, setPosts] = useState();


    //....................................
    const savePostsToLocalStorage = (posts) => {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(posts))
    }

    //....................
    const loadPostsFromLocalStorage = () => {
        if (JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) === null) {
            return []
        } else {
            return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY))
        }
    }

    //-- useEffects ---------------------------------- 
    useEffect(() => {
        const posts = loadPostsFromLocalStorage()
        setPosts(posts)
    }, [])

    //....
    useEffect(() => {
        if (posts) {
            savePostsToLocalStorage(posts)
        }
    }, [posts])

    //----------------------------------------

    const addPost = (title, text) => {
        const newPost =
        {
            title: title,
            text: text,
            id: uuidv4()
        }
        setPosts([...posts, newPost]);
    }


    const deletePost = (post) => {
        const res = posts.filter(e => (e.id !== post.id))
        setPosts(res)
    }

    return [posts, setPosts, addPost, deletePost];


}

export default usePosts;